import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/logo/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-02686892"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-darkgray" }
const _hoisted_2 = { class: "navbar navbar-expand-lg navbar-light shadow-none scrolling-navbar double-nav py-3" }
const _hoisted_3 = { class: "container align-items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons text-primary icon-cart" }, "shopping_cart", -1))
const _hoisted_5 = {
  key: 0,
  class: ""
}
const _hoisted_6 = { class: "d-inline-block align-middle" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = { class: "small d-none d-lg-flex flex-column text-left mb-auto mt-auto" }
const _hoisted_9 = { class: "font-weight-bold d-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons text-primary icon-user" }, "person", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode()
const _hoisted_12 = { class: "mb-0 font-weight-bold" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons text-primary icon-user" }, "person", -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Acceder ")
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeaderForm = _resolveComponent("TheHeaderForm")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LoginForm = _resolveComponent("LoginForm")!
  const _component_MDBModalBody = _resolveComponent("MDBModalBody")!
  const _component_MDBModal = _resolveComponent("MDBModal")!
  const _component_TheCategoryPanel = _resolveComponent("TheCategoryPanel")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "logo",
          src: _imports_0,
          alt: "IWARI",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToHome()))
        }),
        _createVNode(_component_TheHeaderForm),
        _createVNode(_component_router_link, {
          to: "/",
          class: "mx-4 d-flex align-items-center"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        (_ctx.loggedIn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_router_link, { to: "/account" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _hoisted_10,
                          _hoisted_11,
                          _createElementVNode("h6", _hoisted_12, _toDisplayString(_ctx.firstName), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("span", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modal = true)),
              class: "d-flex align-items-center text-primary font-weight-semibold small pointer"
            }, _hoisted_15)),
        _createVNode(_component_MDBModal, {
          show: _ctx.modal,
          modelValue: _ctx.modal,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modal) = $event)),
          centered: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_MDBModalBody, null, {
              default: _withCtx(() => [
                _createVNode(_component_LoginForm, {
                  onToRecovery: _ctx.goToRecovery,
                  onToRegister: _ctx.goToRegister
                }, null, 8, ["onToRecovery", "onToRegister"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["show", "modelValue"])
      ])
    ]),
    _createVNode(_component_TheCategoryPanel)
  ]))
}